import { render, staticRenderFns } from "./DataStatistics.vue?vue&type=template&id=0c22600a&"
import script from "./DataStatistics.vue?vue&type=script&lang=js&"
export * from "./DataStatistics.vue?vue&type=script&lang=js&"
import style0 from "./DataStatistics.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports